import React, { useState } from "react";
import { IoTime } from "react-icons/io5";
import { formatDateTime } from "../../Helpers/Utils";
import { Link } from "react-router-dom";
import Select from "react-select";
import PageChanger from "./Pagination1";
import TablePlaceHolder from "./TablePlaceHolder";

const selectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? "#f16436" : base.borderColor,
        boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
        "&:hover": { borderColor: "#f16436" },
    }),
    option: (style, state) => ({
        ...style,
        backgroundColor: state.isSelected
            ? "#f16436"
            : state.isFocused || state.isActive
                ? "#f164361a"
                : "white",
        color: state.isSelected ? "white" : "black",
    }),
};

const Timeline = ({ userLog, className, loading = false, pageNo = 1, next = false, onPageChange, count = 10, onCountChange, }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleDetails = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={`card shadow-sm rounded-4 timeline-card ${className || ""}`}>
            <div className="p-3">
                <h5 className="fw-semibold d-flex align-items-center gap-2">
                    <IoTime /> Log
                </h5>
                <hr className="m-0" />
            </div>

            <div className="card-body timeline-body">
                {loading ? ("") : userLog?.length > 0 ? (
                    userLog.map((log, i) => (
                        <div key={i} className="timeline-item">
                            <div className={`timeline-dot ${log?.priority ? "priority" : ""}`}>
                                {log?.action?.charAt(0)}
                            </div>
                            <div className="timeline-content">

                                <div className="d-flex justify-content-between flex-wrap">
                                    <div>
                                        <div className="fw-semibold action-title">
                                            {log?.action}
                                            <span className="badge bg-light text-dark ms-2">
                                                {log?.userType}
                                            </span>
                                        </div>

                                        <div className="text-muted small">
                                            {log?.msg}
                                        </div>
                                    </div>

                                    <div className="text-muted small text-end">
                                        {formatDateTime(log?.createdAt)}
                                    </div>
                                </div>

                                <div className="meta-info mt-2">
                                    <span>{log?.previousData?.msg} {"("} {log?.userType === "Admin" ? log?.id : log?.userType === "Staff" ? <Link className="btn-link text-capitalize" to={`/subadmin/view/${log?.createdId}`} >{log?.id}</Link> : ""} {")"}</span>
                                </div>

                                {log?.previousData?.data && (
                                    <button className="btn btn-sm btn-link mt-2 p-0" onClick={() => toggleDetails(i)} >
                                        {openIndex === i ? "Hide Changes ▲" : "View Changes ▼"}
                                    </button>
                                )}

                                {openIndex === i && (
                                    <div className="change-box mt-2">
                                        <pre>
                                            {JSON.stringify(log?.previousData?.data, null, 2)}
                                        </pre>
                                    </div>
                                )}

                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-muted">No activity found</p>
                )}
            </div>

            {/* ---------- pagination ---------- */}
            {(userLog?.length > 0 || Number(pageNo) > 1) && (
                <div className="card-footer bg-transparent border-0 pb-3">
                    <div className="d-flex align-items-center justify-content-end">
                        <span className="me-2 fw-medium">Page Count: </span>
                        <Select
                            className="inside-select"
                            isDisabled={loading}
                            styles={selectStyles}
                            value={{ label: count || 10, value: count || 10 }}
                            options={[10, 20, 30, 40, 50].map((v) => ({ label: v, value: v }))}
                            onChange={(selected) => {
                                onCountChange?.(Number(selected?.value));
                                onPageChange?.(1);
                            }}
                            placeholder="PageNo"
                        />
                    </div>
                    <PageChanger
                        previousValue={Number(pageNo) > 1}
                        nextValue={next}
                        current={Number(pageNo)}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </div>
    );
};

export default Timeline;